import { NHL_COINS_EDITION_ID } from '~containers/analytics/kpis/sources/nhl-coins-edition';
import {
    ServedEdition,
    useServedEdition,
} from '~containers/analytics/use-served-edition';

export type NhlCoinsEdition = ServedEdition;

/**
 * The NHL Coins editions the API serves, the one the page reads, and its
 * window.
 */
export const useNhlCoinsEdition = (): NhlCoinsEdition =>
    useServedEdition({
        gameKind: 'nhl-coins',
        defaultEditionId: NHL_COINS_EDITION_ID,
        gameLabel: 'NHL Coins',
    });
